// extracted by mini-css-extract-plugin
module.exports = {"Input":"Checkbox_Input__3x2A2","Label":"Checkbox_Label__AIF5h","InputElement":"Checkbox_InputElement__kXvon","Invalid":"Checkbox_Invalid__zZplc"};